import React from "react"
import Contest from "./teaser/Contest"
import Deal from "./teaser/Deal"
import Gallery from "./teaser/Gallery"
import Overview from "./teaser/Overview"
import Poll from "./teaser/Poll"
import Question from "./teaser/Question"
import { Teaser, TeaserGalleryItem, TeaserVideo } from "./teaser/Teaser"

const widgets = {
  overview: Overview,
  video: TeaserVideo,
  teaser: Teaser,
  gallery: Gallery,
  gallery_item: TeaserGalleryItem,
  question: Question,
  poll: Poll,
  deal: Deal,
  daily_contest: Contest,
}

const FallbackWidget = ({ title }) => (
  <div className="bg-error">This component "{title}" does not exist.</div>
)

export const Item = React.memo(({ view_widget, ...props }) => {
  // Switch default teasers by model_type
  if (view_widget === "teaser") {
    switch (props.model_type) {
      case "Offer":
        view_widget = "deal"
    }
  }

  let Component = widgets[view_widget]

  return Component ? (
    <>
      {props.teaser_id && <a name={"/" + props.teaser_id} />}
      <Component {...props} />
    </>
  ) : (
    <FallbackWidget title={view_widget} />
  )
})

export default Item
